export class ChangePasswordModel {
  currentPassword?: string | null | undefined;
  newPassword?: string | null | undefined;
}
